import { useColorModeValue } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, Image, Progress, Text, TextProps } from '@bonusly/design-system';

import { useRecognitionProgress } from '../hooks/use-progress';
import { Person } from '../types';

interface ProgressBarProps {
	people: Person[];
}

export const ProgressBar: FC<ProgressBarProps> = ({ people }) => {
	const { t } = useTranslation('tracker_widget');
	const progressBg = useColorModeValue('white', 'blueAlpha.300');

	const { directReportsRecognized, directReportsTotal, recognitionFace, recognitionSvgPos, recognitionVisualProgress } = useRecognitionProgress(people);

	return (
		<Box padding={3} borderRadius="md" background="blueAlpha.200" position="relative">
			<Flex justifyContent="space-between" alignItems="end" mb={1}>
				<StyledProgressLabel>{t('progress_bar.recognized_title')}</StyledProgressLabel>
				<StyledProgressLabel>
					{directReportsRecognized}/{directReportsTotal}
				</StyledProgressLabel>
			</Flex>
			<Progress
				aria-label={t('progress_bar.recognition_progress_label', {
					recognized: directReportsRecognized,
					total: directReportsTotal,
				})}
				value={recognitionVisualProgress}
				height={6}
				borderRadius={100}
				backgroundColor={progressBg}
				styleConfig={{
					baseStyle: {
						filledTrack: {
							backgroundColor: 'blue.200',
						},
					},
				}}
			>
				<Image src={recognitionFace} style={recognitionSvgPos} alt="" />
			</Progress>
		</Box>
	);
};

export const StyledProgressLabel = (props: TextProps) => {
	return <Text fontSize={1} fontWeight="semibold" lineHeight={5} {...props} />;
};
